__turbopack_context__.v({
  "root": "SleepCard-module__peaWIa__root" + " " + __turbopack_context__.i(975967)["BentoCardSizeCss"],
});
